import {observer} from "mobx-react";
import {AccordionContentBox} from "./boxes/accordion-content.box";

interface AccordionContentProps {
    content: React.ReactElement;
    isOpen: boolean;
}
export const AccordionContentComponent: React.FC<AccordionContentProps> = observer((props) => {
    return (
        <AccordionContentBox isOpen={props.isOpen}>
            {props.content}
        </AccordionContentBox>
    )
})